import {kitFetch} from "@ekultur/fetch";

export const getMuseum = id => kitFetch(`/museum-api/museums/${id}`).then(json => json.museum)


